module.exports = __webpack_public_path__ + "img/default-avatar.6518b7ed.svg";